import { Link } from "react-router-dom";
import { useApp } from "@/context/AppContext";
import { Instagram, Facebook, Youtube, MessageCircle } from "lucide-react";
import { DivineCartMark } from "@/components/Logo";

export default function Footer() {
  const { settings } = useApp();
  return (
    <footer className="mt-24 bg-[#1a0f0a] text-[#f5e9d3]">
      <div className="max-w-7xl mx-auto px-4 py-14 grid grid-cols-2 md:grid-cols-5 gap-10">
        <div className="col-span-2">
          <div className="flex items-center gap-3">
            <DivineCartMark size={46} />
            <div>
              <div className="font-serif text-2xl tracking-tight">Divine<span className="text-[#F47920]">Cart</span></div>
              <div className="text-xs uppercase tracking-[0.3em] opacity-70">Puja · Kits · Bhakti</div>
            </div>
          </div>
          <p className="mt-5 text-sm opacity-80 max-w-sm leading-relaxed">
            India's trusted destination for authentic Puja Samagri, Puja Kits, Havan essentials, Idols, Rudraksha, and Spiritual products. Delivered with devotion, packed with care.
          </p>
          <div className="mt-5 flex gap-3">
            <a href={`https://wa.me/${(settings.whatsapp||"").replace(/[^0-9]/g,"")}`} className="p-2 rounded-full bg-white/10 hover:bg-white/20" data-testid="footer-whatsapp"><MessageCircle className="w-4 h-4"/></a>
            <a href="#" className="p-2 rounded-full bg-white/10 hover:bg-white/20"><Instagram className="w-4 h-4"/></a>
            <a href="#" className="p-2 rounded-full bg-white/10 hover:bg-white/20"><Facebook className="w-4 h-4"/></a>
            <a href="#" className="p-2 rounded-full bg-white/10 hover:bg-white/20"><Youtube className="w-4 h-4"/></a>
          </div>
        </div>
        <div>
          <div className="text-xs uppercase tracking-[0.2em] text-[#D4AF37] mb-4">Shop</div>
          <ul className="space-y-2 text-sm">
            <li><Link to="/category/puja-samagri">Puja Samagri</Link></li>
            <li><Link to="/kits">Puja Kits</Link></li>
            <li><Link to="/category/havan-samagri">Havan Samagri</Link></li>
            <li><Link to="/category/idols-murtis">Idols</Link></li>
            <li><Link to="/category/agarbatti">Agarbatti</Link></li>
            <li><Link to="/category/rudraksha">Rudraksha</Link></li>
          </ul>
        </div>
        <div>
          <div className="text-xs uppercase tracking-[0.2em] text-[#D4AF37] mb-4">Company</div>
          <ul className="space-y-2 text-sm">
            <li><Link to="/" data-testid="footer-home">Home</Link></li>
            <li><Link to="/about" data-testid="footer-about">About Us</Link></li>
            <li><Link to="/contact" data-testid="footer-contact">Contact Us</Link></li>
            <li><Link to="/guides">Puja Guides</Link></li>
          </ul>
        </div>
        <div>
          <div className="text-xs uppercase tracking-[0.2em] text-[#D4AF37] mb-4">Policies</div>
          <ul className="space-y-2 text-sm">
            <li><Link to="/shipping-policy" data-testid="footer-shipping">Shipping & Delivery</Link></li>
            <li><Link to="/refund-policy" data-testid="footer-refund">Refund & Cancellation</Link></li>
            <li><Link to="/return-policy" data-testid="footer-return">Return & Replacement</Link></li>
            <li><Link to="/privacy" data-testid="footer-privacy">Privacy Policy</Link></li>
            <li><Link to="/terms" data-testid="footer-terms">Terms & Conditions</Link></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10 bg-black/20">
        <div className="max-w-7xl mx-auto px-4 py-5 grid md:grid-cols-2 gap-3 text-xs opacity-80">
          <div>
            <div className="font-medium text-[#f5e9d3]/90">Registered Business Address</div>
            <div className="opacity-80 mt-0.5">{settings.address || <span className="italic">Address to be configured in Admin → Settings</span>}</div>
          </div>
          <div className="md:text-right">
            <div className="font-medium text-[#f5e9d3]/90">Customer Support</div>
            <div className="opacity-80 mt-0.5">
              {settings.email && <>Email: <a href={`mailto:${settings.email}`} className="underline">{settings.email}</a></>}
              {settings.phone && <> · Phone: <a href={`tel:${settings.phone}`} className="underline">{settings.phone}</a></>}
              {!settings.email && !settings.phone && <span className="italic">Contact details to be configured</span>}
            </div>
            <div className="opacity-70 mt-0.5">{settings.support_hours}</div>
          </div>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-4 py-5 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs opacity-70">
          <span>© {new Date().getFullYear()} DivineCart — Made with devotion in Bharat 🇮🇳</span>
          <span>UPI · Cards · Netbanking · COD · GST-Ready Invoices</span>
        </div>
      </div>
    </footer>
  );
}
